export default __webpack_public_path__ + "assets/images/5e5d490ba3719f86ab792639f9c7de1e.png";